import { DashConfigs } from './dashboardConfigs';

export type Config = {
  [K: number]: Partial<DashConfigs> & {
    nameString?: string;
    keyword?: string;
  };
};

export const brandConfigs: Config = {
  // Cencosud Jumbo
  455: {
    ApprovedTasksCO: true,
  },
  // Cencosud Supervisores BID
  335: {
    ApprovedTasksCO: true,
  },
  // Dislicores
  820: {
    ApprovedTasksCO: true,
    nameString: 'IDENTIFICADOR',
    keyword: 'pedido',
  },
  // Farmu
  632: {
    ApprovedTasksCO: true,
    nameString: 'IDENTIFICADOR',
    keyword: 'pedido',
  },
  // Bodegas Alianza Delivery
  575: {
    ApprovedTasksMX: true,
  },
  // Sigma Delivery BID1
  733: {
    ApprovedTasksMX: true,
  },
  // GPA Separado
  934: {
    ApprovedTasksBR25: true,
    keyword: 'pedido',
    nameString: 'IDENTIFICADOR',
  },
  // Zona Sul Separador
  746: {
    ApprovedTasksBR25: true,
    KeywordCrossCheck: {
      isNumeric: false,
    },
    nameString: 'NÚMERO',
    keyword: 'pedido',
  },
  // Cencosud Bretas Separador
  634: {
    ApprovedTasksBR25: true,
  },
  // Exuto Separador
  803: {
    ApprovedTasksBR40: true,
    KeywordCrossCheck: {
      isNumeric: false,
    },
    keyword: 'pedido',
    nameString: 'IDENTIFICADOR',
  },
  //  Perini Separador
  762: {
    ApprovedTasksBR40: true,
    KeywordCrossCheck: {
      isNumeric: false,
    },
    nameString: 'IDENTIFICADOR',
    keyword: 'pedido',
  },
  // Atacadao Delivery
  732: {
    KeywordCrossCheck: {
      isNumeric: false,
    },
    keyword: 'pedido',
    nameString: 'IDENTIFICADOR',
  },
  // Clubbi Separador BID
  913: {
    KeywordCrossCheck: {
      isNumeric: false,
    },
    keyword: 'especifique',
    nameString: 'ROTA',
  },
  // Brand Makro Orientadores CO
  1090: {
    ApprovedTasksCO: true,
  },
};
